import {
    Component,
    Input,
    OnInit,
    TemplateRef,
    ChangeDetectionStrategy
} from "@angular/core";
import { ArbetsorderTidpunktDTO } from "~app/common/models/planera/ArbetsorderTidpunktDTO";
import { IArbetsorder } from "~app/features/planera/model/IArbetsorder";
import { IOperationBase } from "~app/features/planera/model/IOperationBase";
import { ISearchResponseRow, ISearchResultRenderer } from "../../quick-search.models";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { ArbetsorderInfoIconComponent } from "../../../arbetsorder-info-icon/arbetsorder-info-icon.component";

@Component({
    selector: "rask-arbetsorder-renderer",
    templateUrl: "arbetsorder-renderer.component.html",
    styleUrls: [
        "arbetsorder-renderer.component.scss",
        "../default-renderer.component.scss"
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgbPopover,
        ArbetsorderInfoIconComponent
    ]
})
export class ArbetsorderRendererComponent implements ISearchResultRenderer, OnInit {
    @Input() input: ISearchResponseRow;
    @Input() tooltipTemplate: TemplateRef<any>;

    arbetsorder: IArbetsorder;

    ngOnInit(): void {
        if (this.input) {
            this.arbetsorder = this.metaDataToIArbetsorder();
        }
    }

    private metaDataToIArbetsorder(): IArbetsorder {
        return {
            beteckning: this.input.metadata.naturalKey,
            anskaffningsform: this.input.metadata.anskaffningsform,
            avverkningsgruppForkortning: this.input.metadata.avverkningsgruppForkortning,
            produktionsstatus: this.input.metadata.produktionsstatus,
            planeringsstatus: this.input.metadata.planeringsstatus,
            periodsattPeriod: this.input.metadata.periodsattPeriod,
            operationer: this.input.metadata.hasOperationer ? [{ id: 1 } as IOperationBase] : [],
            tidpunkter: {
                skotningPaborjadDatum: this.input.metadata.skotningPaborjadDatum,
                skotningAvslutadDatum: this.input.metadata.skotningAvslutadDatum,
                skordningPaborjadDatum: this.input.metadata.skordningPaborjadDatum,
                slutrapporteradDatum: this.input.metadata.slutrapporteradDatum
            } as unknown as ArbetsorderTidpunktDTO
        } as unknown as IArbetsorder;
    }
}
